import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import {
  FormInput,
  FormTemplate,
  //   FormTextArea,
  FormSelect,
  CustomSearchableSelect,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm, useFieldArray } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import { useLocation, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
// import { MdCheckBoxOutlineBlank } from "react-icons/md";
import {
  CreateJobListing,
  GetApplication,
  GetJobTitle,
  GetQualifications,
  GetSingleJobListing,
  GetSkills,
  GetUnits,
  UpdateJobListing,
} from "../../../../../utils/redux/HR/HRSlice";
import { toast } from "react-toastify";

export default function UpdateRecruitment() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { get_singlejoblisting } = useSelector((state) => state?.hr);

  const acq = get_singlejoblisting?.responseObject;

  // Default form values
  const defaultData = {
    jobTitle: Number(acq?.jobTitleId),
    yearsOfExperience: acq?.yearsOfExperience,
    openingDate: acq?.openingDate ? acq.openingDate.split("T")[0] : "",
    closingDate: acq?.closingDate ? acq.closingDate.split("T")[0] : "",
    skills:
      acq?.jobListingSkills?.map((skill) => skill.skillId.toString()) || [],
    qualifications:
      acq?.jobListingQualifications?.map((qualification) =>
        qualification.qualificationId.toString()
      ) || [],
    channels:
      acq?.jobListingChannels?.map((channel) => channel.channelId.toString()) ||
      [],
    unitId: acq?.containerId,
  };

  console.log("defaultData", defaultData);
  console.log("acq", acq);

  const formMethods = useForm({
    defaultValues: defaultData,
    mode: "all",
  });

  const {
    handleSubmit,
    register,
    reset,
    formState: { isSubmitting },
  } = formMethods;
  const [selectedJob, setSelectedJob] = useState(null);

  // Fetch Redux data
  const { job_title, get_skills, get_qualifications, get_application } =
    useSelector((state) => state?.hr);

  const jobs = job_title?.responseObject?.pageItems || [];
  const skills = get_skills?.responseObject?.pageItems || [];
  const qualifications = get_qualifications?.responseObject?.pageItems || [];
  const applications = get_application?.result || [];
  const units = useSelector(
    (state) => state?.hr?.units?.responseObject?.pageItems || []
  );

  const apiData = {
    pageSize: 1000,
    pageNumber: 1,
    approvalStatus: 0,
    ApprovalStatusEnum: 0,
  };

  const apiDataSKills = {
    pageSize: 1000,
    pageNumber: 1,
    approvalStatus: 0,
  };

  useEffect(() => {
    // Fetch required data
    dispatch(GetJobTitle(apiData));
    dispatch(GetSkills(apiDataSKills));
    dispatch(GetQualifications(apiData));
    dispatch(GetApplication(apiData));
    dispatch(GetUnits(apiData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Load form default data when `acq` changes
  useEffect(() => {
    if (acq) {
      reset({
        jobTitle: Number(acq?.jobTitleId),
        yearsOfExperience: acq?.yearsOfExperience,
        openingDate: acq?.openingDate ? acq.openingDate.split("T")[0] : "",
        closingDate: acq?.closingDate ? acq.closingDate.split("T")[0] : "",
        skills:
          acq?.jobListingSkills?.map((skill) => skill.skillId.toString()) || [],
        qualifications:
          acq?.jobListingQualifications?.map((qualification) =>
            qualification.qualificationId.toString()
          ) || [],
        channels:
          acq?.jobListingChannels?.map((channel) =>
            channel.channelId.toString()
          ) || [],
        unitId: acq?.containerId,
      });
    }
  }, [acq, reset]);

  // Submit handler
  const submit = async (data) => {
    console.log("Submitted Data: ", selectedJob, data);
    try {
      // Transform and validate data
      const payload = {
        jobListinggId: Number(id),
        jobTitleId: Number(data?.jobTitle),
        containerId: Number(data?.unitId),
        yearsOfExperience: data?.yearsOfExperience,
        openingDate: FormatDateTime(data?.openingDate, "DD/MM/YYYY"),
        closingDate: FormatDateTime(data?.closingDate, "DD/MM/YYYY"),
        skillIds: data?.skills.map((skill) => Number(skill)),
        qualificationIds: data?.qualifications.map((qualification) =>
          Number(qualification)
        ),
        channelIds: data?.channels.map((channel) => Number(channel)),
      };

      // Dispatch API action
      const response = await dispatch(UpdateJobListing(payload));

      if (response?.payload?.successful) {
        toast.success(response?.payload?.statusMessage);
        navigate("/dashboard/hr/recruitment-service/recruitment-process");
      } else {
        toast.error(
          response?.payload?.statusMessage || "Failed to submit data."
        );
      }
    } catch (error) {
      console.error("Error Submitting: ", error);
      toast.error("An error occurred while submitting.");
    }
  };

  useEffect(() => {
    dispatch(GetSingleJobListing({ Id: id }));
  }, [dispatch, id]);

  console.log("acq", acq?.jobTitleId);

  return (
    <PageLayout title={"Update Recruitment Process"} hasBack={true}>
      <FormProvider {...formMethods}>
        <FormTemplate
          className={DashboardStyle.view_app_components}
          handleSubmit={handleSubmit(submit)}
        >
          {/* Basic Information Section */}
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Basic Information
            </h4>
            <div className={DashboardStyle.inputs_group}>
              <div>
                <FormSelect
                  title={"Job Title"}
                  camelCase={"jobTitle"}
                  placeholder={"Select"}
                  array={
                    <>
                      {jobs?.map((job, index) => (
                        <option key={index} value={job?.id}>
                          {job?.title}
                        </option>
                      ))}
                    </>
                  }
                  moreRegister={{
                    onChange: (e) => {
                      const selected = jobs.find(
                        (job) => Number(job?.id) === Number(e.target.value)
                      );
                      setSelectedJob(selected);
                    },
                  }}
                />
                <FormSelect
                  title={"Years of Experience"}
                  camelCase={"yearsOfExperience"}
                  placeholder={"Select"}
                  array={
                    <>
                      <option value="1-2">1-2</option>
                      <option value="3-5">3-5</option>
                      <option value="6-10">6-10</option>
                    </>
                  }
                />
              </div>
              {/* Responsibilities */}
              {selectedJob?.jobResponsibilities && (
                <section className="flex flex-col gap-1">
                  <label className="text-sm font-medium text-gray-700 mb-1">
                    Responsibilities
                  </label>
                  <div className="flex flex-col border border-md min-h-[200px]">
                    {selectedJob?.jobResponsibilities?.map(
                      (responsibility, index) => (
                        <p key={index} className="p-2 border-b border-md">
                          - {responsibility?.jobDescription}
                        </p>
                      )
                    )}
                  </div>
                </section>
              )}
              <div>
                <FormInput
                  title={"Opening Date"}
                  camelCase={"openingDate"}
                  type="date"
                />
                <FormInput
                  title={"Closing Date"}
                  camelCase={"closingDate"}
                  type="date"
                />
              </div>
            </div>
          </section>

          {/* Skills Section */}
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>Skills</h4>
            <div className={DashboardStyle.hflex}>
              <div className={DashboardStyle.mycontainer}>
                {skills?.map((skill, index) => (
                  <label key={index} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      value={skill?.id}
                      {...register("skills")}
                      className="mr-2"
                    />
                    {skill?.name}
                  </label>
                ))}
              </div>
            </div>
          </section>

          {/* Qualifications Section */}
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Qualifications
            </h4>
            <div className={DashboardStyle.hflex}>
              <div className={DashboardStyle.mycontainer}>
                {qualifications?.map((qualification, index) => (
                  <label key={index} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      value={qualification?.id}
                      {...register("qualifications")}
                      className="mr-2"
                    />
                    {qualification?.qualification}
                  </label>
                ))}
              </div>
            </div>
          </section>

          {/* Channels Section */}
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>Channels</h4>
            <div className={DashboardStyle.hflex}>
              <div className={DashboardStyle.mycontainer}>
                {applications?.map((channel, index) => (
                  <label key={index} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      value={channel?.id}
                      {...register("channels")}
                      className="mr-2"
                    />
                    {channel?.channel}
                  </label>
                ))}
              </div>
            </div>
          </section>

          {/* ContainerId */}
          {/* <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>Container</h4>
            <div className={DashboardStyle.inputs_group}>
              <div>
                <CustomSearchableSelect
                  title={""}
                  camelCase={"unitId"}
                  placeholder={"Select"}
                  options={units?.map((unit) => ({
                    label: unit?.name,
                    value: unit?.id,
                    Object: unit,
                  }))}
                />
              </div>
            </div>
          </section> */}

          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>Container</h4>
            <div className={DashboardStyle.inputs_group}>
              <div>
                <CustomSearchableSelect
                  title={""}
                  camelCase={"unitId"}
                  placeholder={"Select"}
                  value={defaultData?.unitId} // Ensure the value prop is correctly passed
                  options={units?.map((unit) => ({
                    label: unit?.name,
                    value: unit?.id,
                    Object: unit,
                  }))}
                  onChange={(selected) => {
                    console.log("Selected Unit: ", selected);
                  }}
                />
              </div>
            </div>
          </section>

          {/* Buttons */}
          <div className={DashboardStyle.button_cage}>
            <SupportButtons
              onClick={() => navigate(-1)}
              className={DashboardStyle?.button_cage_weight}
            >
              Cancel
            </SupportButtons>
            <ActionButtons
              isLoading={isSubmitting}
              className={DashboardStyle?.button_cage_weight}
            >
              Submit
            </ActionButtons>
          </div>
        </FormTemplate>
      </FormProvider>
    </PageLayout>
  );
}
